// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aria-error[data-v-ab3e9ede]{text-indent:-10000px}.manage-folders-tooltip[data-v-ab3e9ede]{width:200px!important}", ""]);
// Exports
module.exports = exports;
